import React, { useEffect, useState } from 'react';
import { usePreference } from '../contexts/PreferenceContext';

interface DateTimeHeaderProps {
  darkMode?: boolean;
}

const DateTimeHeader: React.FC<DateTimeHeaderProps> = ({ darkMode = false }) => {
  const [time, setTime] = useState<string>("");
  const [date, setDate] = useState<string>("");
  const { formatTime, formatDate } = usePreference();

  useEffect(() => {
    const update = () => {
      const now = new Date();
      setDate(
        now.toLocaleDateString("en-US", {
          weekday: "long",
          month: "short",
          day: "numeric",
          year: "numeric",
        })
      );
      setTime(formatTime(now));
    };
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
   <div
  className="
    flex flex-col md:flex-row
    items-start md:items-center
    gap-1 md:gap-3
    whitespace-nowrap overflow-hidden
    text-left
  "
  style={{
    minWidth: "120px",
  }}
>
  {/* TIME */}
  <span
    className={`font-semibold tracking-widest ${
      darkMode ? "text-white/80" : "text-gray-700"
    }`}
    style={{
      fontSize: "clamp(16px, 2.5vw, 26px)",
    }}
  >
    {time}
  </span>

  {/* DATE */}
  <span
    className={`${darkMode ? "text-white/50" : "text-gray-500"}`}
    style={{
      fontSize: "clamp(14px, 1.3vw, 18px)",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }}
  >
    {date}
  </span>
</div>

  );
};

export default DateTimeHeader;
